export default "__VITE_ASSET__tkBimAc6__"